import { AloftPrice, ConstellationOneListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn';
import MLSDataInfoSection from './MLSDataInfoSection';
import MlsDataValueWithLabel from './MLSDataValueWithLabel';

const MLSHoaInfo = ({ listingData }: { listingData: ConstellationOneListing }) => (
  <MLSDataInfoSection title="HOA">
    <MLSDataColumn>
      <MlsDataValueWithLabel value={listingData.AssociationYN} label="Property in HOA" />
      <MlsDataValueWithLabel value={listingData.AssociationName} label="Project" />
    </MLSDataColumn>
    <MLSDataColumn>
      <MlsDataValueWithLabel
        value={
          listingData.AssociationFee
            ? AloftPrice.fromNumericPrice(listingData.AssociationFee ?? 0).toString(true)
            : undefined
        }
        label="Homeowners Dues"
      />
      <MlsDataValueWithLabel value={listingData.AssociationFeeFrequency} label="Frequency" />
      {/* <MlsDataValueWithLabel value={listingData.hoa_phone} label="Phone" />
            <MlsDataValueWithLabel value={listingData.is_adult_community} label="Adult Community" /> */}
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSHoaInfo;
